/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable max-lines */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import getErrorMessage from '@tcp/core/src/components/features/account/LoginPage/container/loginUtils/loginErrorMessage.util';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import { closeMiniBag } from '@tcp/core/src/components/common/organisms/Header/container/Header.actions';
import { closeAddedToBag } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import { isCanada, routerPush, WebViewRedirectURL } from '@tcp/core/src/utils';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { getEnableFullPageAuth } from '@tcp/web/src/components/features/content/HomePage/HomePage.selectors';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import logger from '@tcp/core/src/utils/loggerInstance';
import { md5 } from '@tcp/core/src/utils/encoding';
import { SPC_SECTION } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';
import BAG_PAGE_ACTIONS from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import {
  getContactFormValuesFromSS,
  setContactFormValuesInSS,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import { setClickAnalyticsData, trackPageView, trackClick } from '@tcp/core/src/analytics/actions';
import { getSinglePageCheckoutSectionState } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { updateSectionState } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.actions';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import {
  setIsFromCreateAccountFlow,
  setShowVerificationError,
  setShowBriteError,
  setBriteErrorMessage,
} from '@tcp/core/src/components/features/account/CreateAccount/container/CreateAccount.actions';
import setLoaderState from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import {
  getIsShowOTPScreen,
  getShowVerificationError,
  getShowBriteError,
  getBriteErrorMessage,
} from '@tcp/core/src/components/features/account/CreateAccount/container/CreateAccount.selectors';
import utility from '@tcp/core/src/components/features/CnC/Checkout/util/utility';
import {
  resetPassword,
  resetLoginForgotPasswordState,
  setNewPasswordScreenFromLogin,
  saveUserEmailAddress,
} from '../../ForgotPassword/container/ForgotPassword.actions';
import {
  getShowNotificationState,
  getResetEmailResponse,
  toggleSuccessfulEmailSection,
  getNewPasswordScreenFromLogin,
} from '../../ForgotPassword/container/ForgotPassword.selectors';
import {
  getResetPassCodeValidationFlow,
  getSuccess,
} from '../../ResetPassword/container/ResetPassword.selectors';
import {
  login,
  emailSubmit,
  resetLoginInfo,
  setExistingUserResponse,
  generateLoginOTP,
  setShowOTPInputScreen,
  setUserNotExist,
  setIsOtpLimit,
  showEmailFormScreen,
  setIsLocked,
} from './LoginPage.actions';
import {
  closeOverlayModal,
  openOverlayModal,
} from '../../OverlayModal/container/OverlayModal.actions';
import {
  getLoginError,
  shouldShowRecaptcha,
  shouldShowEmailRecaptcha,
  getLoginState,
  getShowErrorModal,
  getLoadingState,
  getExistingUserResponse,
  getIsLoginWithOTPEnabled,
  getIsShowPhoneLoginOption,
  getMaskedPhoneNumber,
  getIsShowOTPInputScreen,
  getUserNotExist,
  getLoginSelectedOption,
  getLoginWithEmailOTPEnabled,
  getIsNewLoginScreenApp,
  getOTPToken,
  getGuestFavMessages,
  getPlccLoadingState,
  getIsOtpLimit,
  getShowEmailScreen,
  getIsLocked,
  getCountryCode,
} from './LoginPage.selectors';
import {
  getUserLoggedInState,
  getplccCardId,
  getplccCardNumber,
  isRememberedUser,
  getUserEmail,
  getUserName,
} from '../../User/container/User.selectors';
import { toastMessageInfo } from '../../../../common/atoms/Toast/container/Toast.actions';
import LoginView from '../views';
import {
  getBonusPointsEventMessaging,
  getIsGuestFavAppEnabled,
  getIsNewLoginScreen,
  getPageNameFromState,
  getBonusPointsEventMessageValue,
  getIsOTpScreenEnabled,
  getCheckoutMetricsStatus,
  getLoginFlowUXEnhancement,
  getIsBriteVerifyForLoginEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import {
  CUSTOMER_HELP_DIRECT_LINK_TEMPLATE,
  CUSTOMER_HELP_DIRECT_ROUTES,
} from '../../CustomerHelp/CustomerHelp.constants';
import { routerReplace } from '../../../../../utils';
import BagPageSelectors from '../../../CnC/BagPage/container/BagPage.selectors';
import LoginPageReducer from './LoginPage.reducer';
import { LoginPageSaga } from './LoginPage.saga';
import { clearCouponTTL } from '../../../CnC/common/organism/CouponAndPromos/container/Coupon.actions';
import CreateAccountReducer from '../../CreateAccount/container/CreateAccount.reducer';
import { CreateAccountSaga } from '../../CreateAccount/container/CreateAccount.saga';
import { setCheckoutMetricsStatus } from '../../../../../reduxStore/actions';
import { CHECKOUT_ROUTES } from '../../../CnC/Checkout/Checkout.constants';

const loginCheckoutUrl = 'login-checkout';
export class LoginPageContainer extends React.PureComponent {
  componentDidMount() {
    const { User, APIConfig, session, emailAddressFromSS } = this.props;
    const pageData = {
      pageName: 'login',
      pageSection: 'profile',
      pageType: 'profile page',
      pageSubSection: '',
      pageSubSection2: '',
    };
    pushEventToAdobeAnalytics('page_view', { pageData, User, APIConfig, session });

    const { isUserLoggedIn, closeOverlay } = this.props;
    if (isUserLoggedIn) {
      const updatedContactFormValues = {
        ...emailAddressFromSS,
        isCreateAccountOtpScreen: false,
      };
      setContactFormValuesInSS({ ...updatedContactFormValues });
    }
    if (isUserLoggedIn && window.history && window.history.back) {
      closeOverlay();
      window.history.back();
    }
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity, complexity
  componentDidUpdate(prevProps) {
    const {
      isUserLoggedIn,
      closeOverlay,
      closeModal,
      variation,
      toastMessage,
      loginError,
      showErrorModal,
      userEmail,
      resetEstimatedTaxData,
      isShowOTPInputScreen,
      isUserNotExist,
      onUserNotExist,
      loginState,
      fromPlccICLogin,
    } = this.props;
    if (isUserNotExist && variation !== 'checkout') {
      routerPush(`/home?target=register-checkout`, '/home/register-checkout?from=SA');
      onUserNotExist(false);
    }
    if (!prevProps.loginError && loginError && !showErrorModal && !isShowOTPInputScreen) {
      const loginErrorMessage = getErrorMessage(loginState);
      toastMessage(loginErrorMessage);
    }
    if (!prevProps.isUserLoggedIn && isUserLoggedIn && !fromPlccICLogin) {
      this.handleLoggedInState();
      if (variation === 'checkout' || fromPlccICLogin) {
        closeModal();
      }
      if (userEmail) {
        const hash = md5(userEmail.toUpperCase());
        setLocalStorage({ key: 'email_hash', value: hash });
        /* eslint no-underscore-dangle: 0 */
        if (window && window._dataLayer) window._dataLayer.email_hash = hash;
      }
      closeOverlay();
      resetEstimatedTaxData();
    }
  }

  componentWillUnmount() {
    const {
      resetLoginState,
      loginError,
      resetAccountOverViewState,
      showPasswordScreen,
      isLoginWithOTPEnabled,
      isOTpScreenEnabled,
      resetOtpLimit,
      resetIsLocked,
    } = this.props;
    if (isOTpScreenEnabled) {
      resetOtpLimit();
      resetIsLocked();
    }
    if (loginError) {
      resetLoginState();
    }
    if (resetAccountOverViewState) {
      resetAccountOverViewState();
    }
    if (isLoginWithOTPEnabled) {
      showPasswordScreen();
    }
  }

  navigate = () => {
    if (
      window.location.href.includes(loginCheckoutUrl) &&
      !window?.location?.href.includes('from=SA')
    ) {
      utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
    } else {
      routerPush('/', '/home');
    }
  };

  openModal = (params) => {
    const { openOverlay, setLoginModalMountState } = this.props;
    if (setLoginModalMountState) {
      setLoginModalMountState(params);
    } else {
      openOverlay(params);
    }
  };

  closeBagModal = (e) => {
    if (e) e.preventDefault();
    const { closeMiniBagDispatch, closeAddedToBagModal } = this.props;
    closeMiniBagDispatch();
    closeAddedToBagModal();
  };

  isCheckoutFlowV2 = (componentType) => componentType === 'loginV2';

  handleLoggedInState = () => {
    const { variation, fullPage, router, componentType } = this.props;
    try {
      const webView = JSON.parse(readCookie('fromMobileApp')) || false;
      if (webView) {
        WebViewRedirectURL();
      } else if (variation !== 'checkout' && fullPage && !this.isCheckoutFlowV2(componentType)) {
        const { successtarget = '/home' } = (router && router.query) || {};
        if (
          successtarget.substr(-5) === '/home' || // if '/home' presents at last in 'successtarget', expected values could be ('/home', '/us/home', '/ca/home')
          successtarget.indexOf('confirmation') !== -1 ||
          successtarget.indexOf('register') !== -1
        ) {
          routerPush('/', '/home');
        } else if (
          successtarget.indexOf(CUSTOMER_HELP_DIRECT_LINK_TEMPLATE.MERGE_MYPLACE_ACCOUNTS) !== -1
        ) {
          routerReplace(
            CUSTOMER_HELP_DIRECT_ROUTES.MERGE_MYPLACE_ACCOUNTS.to,
            CUSTOMER_HELP_DIRECT_ROUTES.MERGE_MYPLACE_ACCOUNTS.asPath
          );
        } else if (window && window.history && window.history.go) {
          window.history.go(-1);
        }
      }
    } catch (err) {
      logger.error({ error: err });
    }
  };

  getMaskedPhoneNumber = (string, n, find, repl) => {
    if (string.length < 1) {
      return '';
    }
    const stringWithDash = string.match(/.{1,3}/g).join('-');
    const stringWithTwoDash = stringWithDash.split(find);
    return stringWithTwoDash.slice(0, n).join(find) + repl + stringWithTwoDash.slice(n).join(find);
  };

  render() {
    const {
      onSubmit,
      onEmailSubmit,
      onUpdateSectionState,
      emailAddressFromSS,
      loginError,
      showErrorModal,
      loginState,
      showRecaptcha,
      resetForm,
      getUserInfoAction,
      resetLoginState,
      SubmitForgot,
      showNotification,
      successFullResetEmail,
      currentForm,
      queryParams,
      setLoginModalMountState,
      onRequestClose,
      variation,
      handleContinueAsGuest,
      showCheckoutModal,
      showLogin,
      userplccCardNumber,
      userplccCardId,
      updateHeader,
      navigation,
      toastMessage,
      resetChangePasswordState,
      isLoading,
      rememberedUserFlag,
      userEmail,
      userName,
      openOverlay,
      closeModal,
      closeOverlay,
      isResetPassCodeValidationEnabled,
      fullPage,
      plccEmail,
      closeAnimationModel,
      fromOnBoarding,
      setUserEmailAddress,
      totalRewards,
      totalPoints,
      isLoginWithOTPEnabled,
      isLoginWithEmailOTPEnabled,
      isShowPhoneLoginOption,
      maskedPhoneNumber,
      isShowOTPInputScreen,
      onGenerateOTP,
      showPasswordScreen,
      handleAfterLogin,
      successMessage,
      clearCouponTTLData,
      router,
      guestFavMessages,
      isBonusPointsEventMessagingEnabled,
      bonusPointEventMessageValue,
      fromPlccICLogin,
      isPlccLoginLoading,
      isNewLoginScreen,
      isOTpScreenEnabled,
      setIsFromCreateAccount,
      setLoader,
      isUnverifiedAccount,
      isOtpLimit,
      isLocked,
      resetOtpLimit,
      showVerificationError,
      setShowEmailFormScreen,
      showEmailFormScreenValue,
      isShowOTPInputScreenCreateAccount,
      existingUserResponse,
      resetIsLocked,
      setShowVerificationErrorAction,
      onPressHandlerForGuestOnBoarding,
      phoneCountryCode,
      loginFlowUXEnhancementEnabled,
      setShowBriteErrorMessage,
      showBriteError,
      briteErrorMessage,
      setBriteErrorMessageData,
      isBriteVerifyForLoginEnabled,
      ...otherProps
    } = this.props;
    const errorMessage = loginError ? getErrorMessage(loginState) : '';
    const initialValues = {
      rememberMe: true,
      savePlcc: true,
      emailAddress: rememberedUserFlag ? userEmail : '',
      plcc_checkbox: !isCanada(),
    };
    if (plccEmail) {
      initialValues.emailAddress = plccEmail;
    }
    const isFullPageView = fullPage && variation !== 'checkout';
    const fullPageAuthEnabled = fullPage;
    const fromGuestFav = router?.query?.fromGuestFav;
    const isNewLoginFlow = fromPlccICLogin ? true : isNewLoginScreen;
    const isLoginWithOTPFlowEnabled = fromPlccICLogin ? true : isLoginWithOTPEnabled;
    const isLoginWithEmailOTPFlowEnabled = fromPlccICLogin ? true : isLoginWithEmailOTPEnabled;
    return (
      <LoginView
        onSubmit={onSubmit}
        onEmailSubmit={onEmailSubmit}
        onUpdateSectionState={onUpdateSectionState}
        emailAddressFromSS={emailAddressFromSS?.emailAddress}
        isExistingUserFromSS={emailAddressFromSS?.isExistingUser}
        phoneNumberSS={
          emailAddressFromSS?.phoneNumber &&
          this.getMaskedPhoneNumber(emailAddressFromSS?.phoneNumber, 3, '-', '')
        }
        isShowPhoneLoginOptionSS={emailAddressFromSS?.isShowPhoneLoginOption}
        loginErrorMessage={errorMessage}
        initialValues={initialValues}
        showRecaptcha={showRecaptcha}
        resetForm={resetForm}
        getUserInfo={getUserInfoAction}
        openModal={this.openModal}
        resetLoginState={resetLoginState}
        SubmitForgot={SubmitForgot}
        showNotification={showNotification}
        successFullResetEmail={successFullResetEmail}
        currentForm={currentForm}
        queryParams={queryParams}
        setLoginModalMountState={setLoginModalMountState}
        onRequestClose={onRequestClose}
        closeAnimationModel={closeAnimationModel}
        fromOnBoarding={fromOnBoarding}
        variation={variation}
        handleContinueAsGuest={handleContinueAsGuest}
        loginError={loginError}
        showErrorModal={showErrorModal}
        showCheckoutModal={showCheckoutModal}
        showLogin={showLogin}
        userplccCardNumber={userplccCardNumber}
        userplccCardId={userplccCardId}
        updateHeader={updateHeader}
        navigation={navigation}
        toastMessage={toastMessage}
        isRememberedUser={rememberedUserFlag}
        resetChangePasswordState={resetChangePasswordState}
        isLoading={isLoading}
        userName={userName}
        openOverlay={openOverlay}
        onClose={this.closeBagModal}
        closeModal={closeModal}
        closeOverlay={closeOverlay}
        isResetPassCodeValidationEnabled={isResetPassCodeValidationEnabled}
        fullPage={isFullPageView}
        fullPageAuthEnabled={fullPageAuthEnabled}
        plccEmail={plccEmail}
        setUserEmailAddress={setUserEmailAddress}
        totalRewards={totalRewards}
        totalPoints={totalPoints}
        rememberedEmail={userEmail}
        isLoginWithOTPEnabled={isLoginWithOTPFlowEnabled}
        isLoginWithEmailOTPEnabled={isLoginWithEmailOTPFlowEnabled}
        isShowPhoneLoginOption={isShowPhoneLoginOption}
        maskedPhoneNumber={
          maskedPhoneNumber && this.getMaskedPhoneNumber(maskedPhoneNumber, 3, '-', '')
        }
        isShowOTPInputScreen={isShowOTPInputScreen}
        onGenerateOTP={onGenerateOTP}
        showPasswordScreen={showPasswordScreen}
        handleAfterLogin={handleAfterLogin}
        {...otherProps}
        successMessage={successMessage}
        clearCouponTTLData={clearCouponTTLData}
        fromGuestFav={fromGuestFav}
        guestFavMessages={guestFavMessages}
        isBonusPointsEventMessagingEnabled={isBonusPointsEventMessagingEnabled}
        bonusPointEventMessageValue={bonusPointEventMessageValue}
        fromPlccICLogin={fromPlccICLogin}
        isPlccLoginLoading={isPlccLoginLoading}
        isNewLoginScreen={isNewLoginFlow}
        isOTpScreenEnabled={isOTpScreenEnabled}
        setIsFromCreateAccount={setIsFromCreateAccount}
        setLoader={setLoader}
        sessionStorageUserInfo={emailAddressFromSS}
        isUnverifiedAccount={isUnverifiedAccount}
        isOtpLimit={isOtpLimit}
        isLocked={isLocked}
        resetOtpLimit={resetOtpLimit}
        showVerificationError={showVerificationError}
        showEmailFormScreen={showEmailFormScreenValue}
        setShowEmailFormScreen={setShowEmailFormScreen}
        isShowOTPInputScreenCreateAccount={isShowOTPInputScreenCreateAccount}
        existingUserResponse={existingUserResponse}
        resetIsLocked={resetIsLocked}
        setShowVerificationErrorAction={setShowVerificationErrorAction}
        onPressSetupLater={onPressHandlerForGuestOnBoarding}
        phoneCountryCode={phoneCountryCode}
        loginFlowUXEnhancementEnabled={loginFlowUXEnhancementEnabled}
        setShowBriteErrorMessage={setShowBriteErrorMessage}
        showBriteError={showBriteError}
        setBriteErrorMessageData={setBriteErrorMessageData}
        briteErrorMessage={briteErrorMessage}
        isBriteVerifyForLoginEnabled={isBriteVerifyForLoginEnabled}
      />
    );
  }
}
LoginPageContainer.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  resetLoginState: PropTypes.func,
  clearCouponTTLData: PropTypes.func,
  isUserLoggedIn: PropTypes.bool,
  closeOverlay: PropTypes.func,
  loginError: PropTypes.bool,
  showRecaptcha: PropTypes.bool,
  resetForm: PropTypes.bool.isRequired,
  getUserInfoAction: PropTypes.bool.isRequired,
  openOverlay: PropTypes.func,
  navigation: PropTypes.shape({}),
  SubmitForgot: PropTypes.bool.isRequired,
  showNotification: PropTypes.bool.isRequired,
  successFullResetEmail: PropTypes.bool.isRequired,
  currentForm: PropTypes.string,
  queryParams: PropTypes.shape({}),
  onRequestClose: PropTypes.shape({}).isRequired,
  setLoginModalMountState: PropTypes.bool.isRequired,
  closeModal: PropTypes.bool.isRequired,
  variation: PropTypes.bool.isRequired,
  handleContinueAsGuest: PropTypes.func,
  toastMessage: PropTypes.string.isRequired,
  showCheckoutModal: PropTypes.func.isRequired,
  showLogin: PropTypes.func.isRequired,
  resetAccountOverViewState: PropTypes.func,
  userplccCardNumber: PropTypes.string.isRequired,
  userplccCardId: PropTypes.string.isRequired,
  updateHeader: PropTypes.func.isRequired,
  resetChangePasswordState: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  rememberedUserFlag: PropTypes.bool,
  userEmail: PropTypes.string,
  userName: PropTypes.string,
  closeMiniBagDispatch: PropTypes.func,
  closeAddedToBagModal: PropTypes.func,
  showErrorModal: PropTypes.bool,
  isResetPassCodeValidationEnabled: PropTypes.bool,
  fullPage: PropTypes.bool,
  router: PropTypes.shape({}),
  plccEmail: PropTypes.string,
  resetEstimatedTaxData: PropTypes.func,
  onEmailSubmit: PropTypes.func,
  emailAddressFromSS: PropTypes.shape({}),
  setUserEmailAddress: PropTypes.func,
  closeAnimationModel: PropTypes.func.isRequired,
  fromOnBoarding: PropTypes.func.isRequired,
  isLoginWithOTPEnabled: PropTypes.bool,
  isShowPhoneLoginOption: PropTypes.bool,
  maskedPhoneNumber: PropTypes.string,
  isShowOTPInputScreen: PropTypes.bool,
  onGenerateOTP: PropTypes.func,
  showPasswordScreen: PropTypes.func,
  isUserNotExist: PropTypes.bool,
  onUserNotExist: PropTypes.func,
  isLoginWithEmailOTPEnabled: PropTypes.bool,
  loginSelectedOption: PropTypes.shape({}),
  isLoginModal: PropTypes.bool,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
  session: PropTypes.shape({}),
};
LoginPageContainer.defaultProps = {
  showRecaptcha: false,
  loginError: false,
  resetLoginState: () => {},
  clearCouponTTLData: () => {},
  closeOverlay: () => {},
  openOverlay: () => {},
  handleContinueAsGuest: () => {},
  isUserLoggedIn: false,
  navigation: {},
  currentForm: '',
  queryParams: {},
  resetAccountOverViewState: () => {},
  resetChangePasswordState: () => {},
  rememberedUserFlag: false,
  userEmail: '',
  userName: '',
  closeMiniBagDispatch: () => {},
  closeAddedToBagModal: () => {},
  showErrorModal: false,
  isResetPassCodeValidationEnabled: false,
  fullPage: false,
  router: {},
  plccEmail: '',
  resetEstimatedTaxData: () => {},
  isLoginWithOTPEnabled: false,
  isShowPhoneLoginOption: false,
  isShowOTPInputScreen: false,
  isUserNotExist: false,
  isLoginWithEmailOTPEnabled: false,
  loginSelectedOption: {},
  isLoginModal: false,
  User: {},
  APIConfig: {},
  session: {},
};
const mapDispatchToProps = (dispatch, props) => {
  return {
    onSubmit: (payload) => {
      dispatch(saveUserEmailAddress(payload.emailAddress));
      const {
        variation = '',
        fullPage = false,
        isRtpsFlow = false,
        componentType,
        fromPlccICLogin,
      } = props;
      const modfiedPayload = {
        ...payload,
        mergeCart: !isRtpsFlow && variation !== 'checkout' && componentType !== 'loginV2',
        fullPage,
        fromPlccICLogin,
      };
      dispatch(login(modfiedPayload, props.handleAfterLogin));
    },
    onUserNotExist: (payload) => {
      dispatch(setUserNotExist(payload));
    },
    onGenerateOTP: (payload) => {
      dispatch(generateLoginOTP(payload));
    },
    onEmailSubmit: (payload) => {
      dispatch(emailSubmit(payload));
    },
    onUpdateSectionState: (payload) => {
      dispatch(updateSectionState(payload));
    },
    saveExistingUserResponse: (payload) => {
      dispatch(setExistingUserResponse(payload));
    },
    resetForm: (payload) => {
      dispatch(resetLoginForgotPasswordState(payload));
    },
    resetLoginState: () => {
      dispatch(resetLoginInfo());
    },
    clearCouponTTLData: () => {
      dispatch(clearCouponTTL());
    },
    SubmitForgot: (payload) => {
      dispatch(resetPassword(payload));
    },
    closeOverlay: () => {
      dispatch(closeOverlayModal());
    },
    openOverlay: (payload) => {
      dispatch(openOverlayModal(payload));
    },
    toastMessage: (palyoad) => {
      dispatch(toastMessageInfo(palyoad));
    },
    closeMiniBagDispatch: () => {
      dispatch(closeMiniBag());
    },
    closeAddedToBagModal: () => {
      dispatch(closeAddedToBag());
    },
    setNewPasswordScreenFromLogin: () => {
      dispatch(setNewPasswordScreenFromLogin(false));
    },
    setUserEmailAddress: (payload) => {
      dispatch(saveUserEmailAddress(payload));
    },
    showPasswordScreen: () => {
      dispatch(setShowOTPInputScreen(false));
    },
    resetEstimatedTaxData: () => {
      dispatch(
        BAG_PAGE_ACTIONS.setZipForTaxEstimation({ zipcode: '', estimatedTaxReduxTTLValue: '' })
      );
      dispatch(BAG_PAGE_ACTIONS.setEstimatedTax({ tax: '', estimatedTaxReduxTTLValue: '' }));
    },
    routeForBagCheckout: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.routeForCheckout(payload));
    },
    setShowEmailFormScreen: (payload) => {
      dispatch(showEmailFormScreen(payload));
    },
    trackAnalyticsPageView: (eventData) => {
      const loadtimer = setTimeout(() => {
        dispatch(setClickAnalyticsData(eventData));
        // Delayed setting of data when redirection on click event
        clearTimeout(loadtimer);
      }, 300);
      const timer = setTimeout(() => {
        dispatch(trackPageView(eventData));
        clearTimeout(timer);
      }, 800);
    },
    trackAnalyticsClick: (eventData, payload) => {
      const clicktimer = setTimeout(() => {
        dispatch(setClickAnalyticsData(eventData));
        // Delayed setting of data when redirection on click event
        clearTimeout(clicktimer);
      }, 350);
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 800);
    },
    setIsFromCreateAccount: (payload) => {
      dispatch(setIsFromCreateAccountFlow(payload));
    },
    setLoader: (payload) => dispatch(setLoaderState(payload)),
    resetOtpLimit: () => {
      dispatch(setIsOtpLimit(false));
    },
    setShowVerificationErrorAction: (payload) => {
      dispatch(setShowVerificationError(payload));
    },
    resetIsLocked: () => {
      dispatch(setIsLocked(false));
    },
    setCheckoutEmailGuestStatus: (payload) => {
      dispatch(setCheckoutMetricsStatus(payload));
    },
    setShowBriteErrorMessage: (payload) => {
      dispatch(setShowBriteError(payload));
    },
    setBriteErrorMessageData: (payload) => {
      dispatch(setBriteErrorMessage(payload));
    },
  };
};
const mapStateToProps = (state) => {
  const contactData = getSinglePageCheckoutSectionState()(state, SPC_SECTION.CONTACT);
  return {
    isLoading: getLoadingState(state),
    isPlccLoginLoading: getPlccLoadingState(state),
    showNotification: getShowNotificationState(state),
    resetForgotPasswordErrorResponse: getResetEmailResponse(state),
    successFullResetEmail: toggleSuccessfulEmailSection(state),
    isUserLoggedIn: getUserLoggedInState(state),
    loginError: getLoginError(state),
    loginState: getLoginState(state),
    showErrorModal: getShowErrorModal(state),
    showRecaptcha: shouldShowRecaptcha(state),
    showEmailRecaptcha: shouldShowEmailRecaptcha(state),
    userplccCardNumber: getplccCardNumber(state),
    userplccCardId: getplccCardId(state),
    rememberedUserFlag: isRememberedUser(state),
    userEmail: getUserEmail(state),
    userName: getUserName(state),
    isResetPassCodeValidationEnabled: getResetPassCodeValidationFlow(state),
    fullPage: getEnableFullPageAuth(state),
    loyaltyPageName: getPageNameFromState(state),
    newPasswordScreenFromLogin: getNewPasswordScreenFromLogin(state),
    existingUserResponse: getExistingUserResponse(state),
    emailAddressFromSS: getContactFormValuesFromSS(contactData),
    totalRewards: BagPageSelectors.getOrdertTotalRewards(state),
    totalPoints: BagPageSelectors.getOrdertTotalPoints(state),
    isLoginWithOTPEnabled: getIsLoginWithOTPEnabled(state),
    isShowPhoneLoginOption: getIsShowPhoneLoginOption(state),
    maskedPhoneNumber: getMaskedPhoneNumber(state),
    isShowOTPInputScreen: getIsShowOTPInputScreen(state),
    isUserNotExist: getUserNotExist(state),
    isLoginWithEmailOTPEnabled: getLoginWithEmailOTPEnabled(state),
    loginSelectedOption: getLoginSelectedOption(state),
    isNewLoginScreenApp: getIsNewLoginScreenApp(state),
    isNewLoginScreen: getIsNewLoginScreen(state),
    successMessage: getSuccess(state),
    otpToken: getOTPToken(state),
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
    guestFavMessages: getGuestFavMessages(),
    isBonusPointsEventMessagingEnabled: getBonusPointsEventMessaging(state),
    bonusPointEventMessageValue: getBonusPointsEventMessageValue(state),
    isGuestFavAppEnabled: getIsGuestFavAppEnabled(state),
    isOTpScreenEnabled: getIsOTpScreenEnabled(state),
    isUnverifiedAccount: getShowVerificationError(state),
    isOtpLimit: getIsOtpLimit(state),
    showVerificationError: getShowVerificationError(state),
    showEmailFormScreenValue: getShowEmailScreen(state),
    isShowOTPInputScreenCreateAccount: getIsShowOTPScreen(state),
    isLocked: getIsLocked(state),
    checkoutEmailEntryStatus: getCheckoutMetricsStatus(state, 'checkout_email'),
    checkoutGuestStatus: getCheckoutMetricsStatus(state, 'checkout_as_guest'),
    phoneCountryCode: getCountryCode(state),
    loginFlowUXEnhancementEnabled: getLoginFlowUXEnhancement(state),
    showBriteError: getShowBriteError(state),
    briteErrorMessage: getBriteErrorMessage(state),
    isBriteVerifyForLoginEnabled: getIsBriteVerifyForLoginEnabled(state),
  };
};
const withReducer = withDynamicReducer([
  { key: 'LoginPageReducer', reducer: LoginPageReducer },
  {
    key: 'CreateAccountReducer',
    reducer: CreateAccountReducer,
  },
]);
const withSaga = useDynamicSaga([
  { key: 'LoginPageSaga', saga: LoginPageSaga },
  { key: 'CreateAccountSaga', saga: CreateAccountSaga },
]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withSaga, withConnect)(LoginPageContainer);
